import { Button, Spinner } from '@heroui/react';
import React, { FC } from 'react';

import { ButtonConfig, NavButton } from './NavButton';
import { Container, LeftElement, RightElement } from './StepNavigation.styled';

export interface BottomCTANavButtonsProps {
  previousButton?: ButtonConfig;
  nextButton?: ButtonConfig;
}

export interface BottomCTANavElementsProps {
  leftSection?:React.ReactNode;
  rightSection?: React.ReactNode;
}

export interface ActionButtonProps {
  showButton?: boolean;
  label?: string;
  onClick?: () => void;
}

export interface ActionsProps {
  next?: ActionButtonProps;
  previous?: ActionButtonProps;
  showSubmit?: boolean;
  nextButton?: boolean;
  onSubmit?: () => void;
  form?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  skipAndSubmit?: boolean;
}

export type BottomCTANavProps = BottomCTANavButtonsProps | BottomCTANavElementsProps | ActionsProps;

export const StepNavigation: FC<BottomCTANavProps> = (props) => {
  const {
    previousButton,
    nextButton,
    leftSection,
    rightSection,
    next,
    form,
    previous,
    showSubmit,
    isDisabled,
    isLoading,
    skipAndSubmit,
  } = props as BottomCTANavButtonsProps & BottomCTANavElementsProps & ActionsProps;
  return (
    <Container>
      <LeftElement>
        {previousButton && (
          <NavButton {...previousButton} direction="previous" />
        )}
        {leftSection}

        {previous && previous.showButton && (
          <Button
            size="md"
            color="primary"
            variant="bordered"
            form="form"
            radius="sm"
            onPress={previous.onClick}
          >
            {previous.label || 'Previous'}
          </Button>
        )}

      </LeftElement>

      <RightElement>
        {skipAndSubmit && !showSubmit
            && (
            <Button
              size="md"
              color="secondary"
              variant="solid"
              type="submit"
              form={form}
              radius="sm"
              className="mr-4 cursor-pointer"
              endContent={isLoading ? <Spinner size="sm" variant="spinner" color="default" /> : null}
              isDisabled={isDisabled}
            >
              Save
            </Button>
            )}
        {nextButton && (
          <NavButton {...nextButton} direction="next" />
        )}
        {rightSection}

        {next && !showSubmit ? (
          <Button
            type="button"
            variant="solid"
            color="primary"
            radius="sm"
            size="md"
            onClick={(e) => {
              e.preventDefault(); // ✅ Prevents accidental form submission
              if (next.onClick) next.onClick();
            }}
          >
            {next.label || 'Next'}
          </Button>
        )
          : (
            <Button
              size="md"
              color="secondary"
              variant="solid"
              type="submit"
              form={form}
              radius="sm"
              startContent={isLoading ? <Spinner size="sm" variant="spinner" color="default" /> : null}
              isDisabled={isDisabled}
            >
              Submit
            </Button>
          )}

      </RightElement>
    </Container>
  );
};
